import ActionType from './actionType';

export const setUser = (user) => ({
  type: ActionType.SET_USER,
  payload: user,
});
